// The OIDC provider (iFixit/Oidc/OidcProviderController.php) redirects
// logged-out users to /Login with the authorize URL in last_page, so login
// must resume it.
const oidcAuthorizePaths = new Set(['/api/2.0/oidc/authorize']);

export function isOidcAuthorizePath(pathname: string): boolean {
   return oidcAuthorizePaths.has(pathname);
}
